<template>

  <div class="sub-hero-section">

    <div class="grid-container">

      <div class="content">

        <span>{{ content.title }}</span>

        <img :src="content.imgSrc">

      </div>


    </div>

  </div>

</template>

<script>

export default {

  name: 'SubHero',

  props: ['content'],

}

</script>

<style lang="scss" scoped>

.sub-hero-section {
  background-color: #4a90e2;
  padding: 20px 0 10px;

  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    span {
      color: rgb(61, 20, 102);
      font-weight: 700;
      margin-bottom: 20px;
      font-size: 1.2em;
    }

    img {
      max-width: 100%;
      width: 782px;
    }

  }

}

@media only screen and (max-width: 425px) {

  .sub-hero-section {

    .content {

      flex-direction: column;
      gap: 25px;
      padding: 20px 15px;

      span {
        font-size: 1em;
      }

    }

  }

}

</style>